import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.onFontsLoadedBind = this.onFontsLoaded.bind(this);
    }

    init() {
        this.bindEvents();

        if (window.isFontsLoaded) {
            this.onFontsLoaded();
        }
    }

    bindEvents() {
        window.addEventListener('fontsLoaded', this.onFontsLoadedBind);
    }

    unbindEvents() {
        window.removeEventListener('fontsLoaded', this.onFontsLoadedBind);
    }

    onFontsLoaded() {
        this.$leftImages = this.el.querySelectorAll('.c-push-stories_slider_left-image .c-push-stories_figure');
        this.$rightImages = this.el.querySelectorAll('.c-push-stories_slider_right-image .c-push-stories_figure');
        this.$quotes = this.el.querySelectorAll('.c-push-stories_slider_quote');

        this.$leftImages[0].classList.add('is-active');
        this.$leftImages[1].classList.add('is-next');
        this.$leftImages[this.$leftImages.length-1].classList.add('is-prev');
        this.$rightImages[0].classList.add('is-active');
        this.$rightImages[1].classList.add('is-next');
        this.$rightImages[this.$rightImages.length - 1].classList.add('is-prev');
        this.$quotes[0].classList.add('is-active');
        this.$quotes[1].classList.add('is-next');
        this.$quotes[this.$quotes.length - 1].classList.add('is-prev');
        this.el.classList.add('-right-direction');
        // console.log('Right');

        this.el.querySelector('.c-push-stories_slider_control.-next').addEventListener('click', () => {
            this.next();
        });

        this.el.querySelector('.c-push-stories_slider_control.-prev').addEventListener('click', () => {
            this.prev();
        });
    }

    next() {
        if (!this.el.classList.contains('is-changing-slide')) {

            this.el.classList.add('is-changing-slide');

            setTimeout(() => {
                this.el.classList.remove('is-changing-slide');
            }, 1200);

            this.el.classList.remove('-left-direction');
            this.el.classList.add('-right-direction');
            // console.log('Right');

            let $activeQuote = this.el.querySelector('.c-push-stories_slider_quote.is-active');
            let $nextQuote = $activeQuote.nextElementSibling;

            if (!$nextQuote) {
                $nextQuote = this.$quotes[0];
            }

            $activeQuote.classList.remove('is-active');
            $nextQuote.classList.add('is-active');

            // PREV
            this.$quotes.forEach(($quote) => {
                $quote.classList.remove('is-prev');
            });
            $activeQuote.classList.add('is-prev');

            // NEXT
            if ($nextQuote.nextElementSibling) {
                this.$quotes.forEach(($quote) => {
                    $quote.classList.remove('is-next');
                });
                $nextQuote.nextElementSibling.classList.add('is-next');
            } else {
                this.$quotes.forEach(($quote) => {
                    $quote.classList.remove('is-next');
                });
                this.$quotes[0].classList.add('is-next');
            }

            let $activeLeftImage = this.el.querySelector('.c-push-stories_slider_left-image .c-push-stories_figure.is-active');
            let nextLeftImage = $activeLeftImage.nextElementSibling;

            if (!nextLeftImage) {
                nextLeftImage = this.$leftImages[0];
            }

            $activeLeftImage.classList.remove('is-active');
            nextLeftImage.classList.add('is-active');

            // PREV
            this.$leftImages.forEach(($leftImage) => {
                $leftImage.classList.remove('is-prev');
            });
            $activeLeftImage.classList.add('is-prev');

            // NEXT
            if (nextLeftImage.nextElementSibling) {
                this.$leftImages.forEach(($leftImage) => {
                    $leftImage.classList.remove('is-next');
                });
                nextLeftImage.nextElementSibling.classList.add('is-next');
            } else {
                this.$leftImages.forEach(($leftImage) => {
                    $leftImage.classList.remove('is-next');
                });
                this.$leftImages[0].classList.add('is-next');
            }

            let $activeRightImage = this.el.querySelector('.c-push-stories_slider_right-image .c-push-stories_figure.is-active');
            let nextRightImage = $activeRightImage.nextElementSibling;

            if (!nextRightImage) {
                nextRightImage = this.$rightImages[0];
            }

            $activeRightImage.classList.remove('is-active');
            nextRightImage.classList.add('is-active');

            // PREV
            this.$rightImages.forEach(($leftImage) => {
                $leftImage.classList.remove('is-prev');
            });
            $activeRightImage.classList.add('is-prev');

            // NEXT
            if (nextRightImage.nextElementSibling) {
                this.$rightImages.forEach(($leftImage) => {
                    $leftImage.classList.remove('is-next');
                });
                nextRightImage.nextElementSibling.classList.add('is-next');
            } else {
                this.$rightImages.forEach(($leftImage) => {
                    $leftImage.classList.remove('is-next');
                });
                this.$rightImages[0].classList.add('is-next');
            }
        }
    }

    prev() {
        if (!this.el.classList.contains('is-changing-slide')) {

            this.el.classList.add('is-changing-slide');

            setTimeout(() => {
                this.el.classList.remove('is-changing-slide');
            }, 1200);

            this.el.classList.remove('-right-direction');
            this.el.classList.add('-left-direction');
            // console.log('Left');

            let $activeQuote = this.el.querySelector('.c-push-stories_slider_quote.is-active');
            let $prevQuote = $activeQuote.previousElementSibling;

            if (!$prevQuote) {
                $prevQuote = this.$quotes[this.$quotes.length - 1];
            }

            $activeQuote.classList.remove('is-active');
            $prevQuote.classList.add('is-active');

            // PREV
            this.$quotes.forEach(($quote) => {
                $quote.classList.remove('is-prev');
            });
            $activeQuote.classList.add('is-prev');

            // NEXT
            if ($prevQuote.previousElementSibling) {
                this.$quotes.forEach(($quote) => {
                    $quote.classList.remove('is-next');
                });
                $prevQuote.previousElementSibling.classList.add('is-next');
            } else {
                this.$quotes.forEach(($quote) => {
                    $quote.classList.remove('is-next');
                });
                this.$quotes[this.$quotes.length - 1].classList.add('is-next');
            }

            let $activeLeftImage = this.el.querySelector('.c-push-stories_slider_left-image .c-push-stories_figure.is-active');
            let prevLeftImage = $activeLeftImage.previousElementSibling;

            if (!prevLeftImage) {
                prevLeftImage = this.$leftImages[this.$leftImages.length - 1];
            }

            $activeLeftImage.classList.remove('is-active');
            prevLeftImage.classList.add('is-active');

            // PREV
            this.$leftImages.forEach(($leftImage) => {
                $leftImage.classList.remove('is-prev');
            });
            $activeLeftImage.classList.add('is-prev');

            // NEXT
            if ($prevQuote.previousElementSibling) {
                this.$leftImages.forEach(($leftImage) => {
                    $leftImage.classList.remove('is-next');
                });
                prevLeftImage.previousElementSibling.classList.add('is-next');
            } else {
                this.$leftImages.forEach(($leftImage) => {
                    $leftImage.classList.remove('is-next');
                });
                this.$leftImages[this.$leftImages.length - 1].classList.add('is-next');
            }

            let $activeRightImage = this.el.querySelector('.c-push-stories_slider_right-image .c-push-stories_figure.is-active');
            let prevRightImage = $activeRightImage.previousElementSibling;

            if (!prevRightImage) {
                prevRightImage = this.$rightImages[this.$rightImages.length - 1];
            }

            $activeRightImage.classList.remove('is-active');
            prevRightImage.classList.add('is-active');

            // PREV
            this.$rightImages.forEach(($rightImage) => {
                $rightImage.classList.remove('is-prev');
            });
            $activeRightImage.classList.add('is-prev');

            // NEXT
            if ($prevQuote.previousElementSibling) {
                this.$rightImages.forEach(($rightImage) => {
                    $rightImage.classList.remove('is-next');
                });
                prevRightImage.previousElementSibling.classList.add('is-next');
            } else {
                this.$rightImages.forEach(($rightImage) => {
                    $rightImage.classList.remove('is-next');
                });
                this.$rightImages[this.$rightImages.length - 1].classList.add('is-next');
            }
        }
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }
}
